import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["completeModal", "recommendationForm"];

  disconnect() {
    // Lifecycle cleanup (no timers or listeners to clear)
  }

  toggleComplete() {
    if (this.hasCompleteModalTarget) {
      this.completeModalTarget.classList.toggle("hidden");
    } else {
      const modal = document.getElementById("complete-modal");
      if (modal) modal.classList.toggle("hidden");
    }
  }

  toggleRecommendation() {
    if (this.hasRecommendationFormTarget) {
      this.recommendationFormTarget.classList.toggle("hidden");
    } else {
      const form = document.getElementById("recommendation-form");
      if (form) form.classList.toggle("hidden");
    }
  }
}
